<template>
  <div class="container">
    <iframe v-if="url" :src="url" width="100%" height="100%" frameborder="0"></iframe>
    <div v-else class="loading-container">
      <el-icon class="is-loading"><Loading /></el-icon>
      <p>正在加载客服系统...</p>
    </div>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  margin-top: 7rem;
  background: #f5f6fa;
  height: 90vh;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 15px;
  color: #666;
}

.loading-container .el-icon {
  font-size: 40px;
  color: #667eea;
}
</style>
<script setup>
import {ref, onMounted, onUnmounted} from 'vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import apiClient from '@/components/plugins/axios'
import { Loading } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import {useRouter} from "vue-router";

const router = useRouter()



const handleMessage = (e) => {
  if (e.data && e.data.type === 'router-jump') {
    router.push(e.data.path);
  }
}
// 卸载时移除监听（防止内存泄漏）
onUnmounted(() => {
  window.removeEventListener('message', handleMessage);
})






// 客服 URL
const url = ref('')

// 获取设备指纹
async function getFingerprint() {
  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    return result.visitorId
  } catch (error) {
    console.error('获取设备指纹失败:', error)
    // 如果获取失败，使用时间戳作为备用
    return Date.now().toString()
  }
}

// 调用游客识别接口
async function identifyGuest() {
  try {
    const fingerprint = await getFingerprint()
    
    const response = await apiClient.post('/api/v1/member/guest/identify', {
      fingerprint: fingerprint,
      source: 'pc'
    })
    
    if (response.data && response.data.code === 200) {
      const data = response.data.data
      return {
        id: data.user_id,
        nickname: data.nickname,
        avatar: data.avatar
      }
    } else {
      throw new Error(response.data?.message || '游客识别失败')
    }
  } catch (error) {
    console.error('游客识别失败:', error)
    ElMessage.error('游客识别失败，请稍后重试')
    return null
  }
}

// 构建客服 URL
function buildCustomerServiceUrl(userInfo) {
  let baseUrl = process.env.VUE_APP_CS_URL + '/livechat?user_id=agent&client_usertype=0&client_source=pc&t=' + Date.now()
  
  if (userInfo) {
    if (userInfo.id) {
      baseUrl += '&client_userid=' + userInfo.id
    }
    if (userInfo.nickname) {
      baseUrl += '&client_nickname=' + userInfo.nickname
    }
    if (userInfo.avatar) {
      baseUrl += '&client_avatar=' + userInfo.avatar
    }
  }
  
  return baseUrl
}

// 初始化
onMounted(async () => {
  window.addEventListener('message', handleMessage);
  // 检查是否登录
  const token = localStorage.getItem('access_token')
  const isLoggedIn = !!token
  
  let userInfo = null
  
  if (isLoggedIn) {
    // 已登录，尝试从 localStorage 获取用户信息
    try {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        userInfo = JSON.parse(userInfoStr)
      }
    } catch (error) {
      console.error('解析用户信息失败:', error)
    }
  }
  
  // 如果没有用户信息，调用游客识别接口
  if (!userInfo || !userInfo.id) {
    const guestInfo = await identifyGuest()
    if (guestInfo) {
      userInfo = guestInfo
    }
  }
  
  // 构建并设置 URL
  url.value = buildCustomerServiceUrl(userInfo)
})
</script>